export default function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_isString.js
// module id = 297
// module chunks = 1